import { useQuery } from "@tanstack/react-query";
import { getMissingStatus } from "./../../sevices/apiMissingReport";

export function useStatusMissing({ start_date, end_date }) {
    const {
        isLoading,
        data: statusMissing,
        error,
        isError,
        refetch,
        isRefetching
    } = useQuery({
        queryKey: [`status-missing`],
        queryFn: () => getMissingStatus({ start_date, end_date }),
    });

    return { isLoading, error, statusMissing, isError, refetch, isRefetching };
}